export class GatewayTimeoutError extends Error {
    message = '504 Gateway timeout error';
}
